import { AnswerElementType } from 'shared/types/AnswerElement';

import { DefaultAnswerConfig } from '@/widgets/utils/generateDefaultAnswer';

export const DEFAULT_ANSWERS_AMOUNT = 3;
export const SELECTION_MAX_COLUMN_AMOUNT = 4;

export const allowedElementTypesCombinations: AnswerElementType[][] = [
  ['Text', 'Image', 'Audio'],
  ['Text' /*, 'Video'*/]
];

export const defaultAnswerConfig: DefaultAnswerConfig = {
  hasText: true,
  hasImage: true,
  hasAudio: true,
  hasVideo: true
};
